// frontend/src/charts/format.ts
const ru = (digits: number) =>
  new Intl.NumberFormat("ru-RU", {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  });

const ruInt = new Intl.NumberFormat("ru-RU");

export const formatRub = (n: number | null): string =>
  n === null ? "—" : ru(0).format(n) + " ₽";

export const formatRubCompact = (n: number | null): string => {
  if (n === null) return "—";
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(2).replace(".", ",") + " млн ₽";
  if (Math.abs(n) >= 10_000) return (n / 1000).toFixed(1).replace(".", ",") + " тыс ₽";
  return ru(0).format(n) + " ₽";
};

export const formatPct = (n: number | null, digits = 1): string =>
  n === null ? "—" : (n * 100).toFixed(digits).replace(".", ",") + "%";

export const formatPctPoints = (n: number | null, digits = 1): string =>
  n === null ? "—" : (n * 100).toFixed(digits).replace(".", ",") + " п.п.";

export const formatInt = (n: number | null): string =>
  n === null ? "—" : ruInt.format(n);

export const formatDate = (iso: string): string => {
  const [, m, d] = iso.split("-");
  return `${d}.${m}`;
};

export function deltaFromValues(current: number | null, previous: number | null): number | null {
  if (current === null || previous === null) return null;
  if (previous === 0) return current === 0 ? 0 : null;
  return (current - previous) / Math.abs(previous);
}
